import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './ns-login-status.js';

import { baseCss } from './css.js';
const nlChangeAccountCss = baseCss;

const NlChangeAccountStyle0 = nlChangeAccountCss;

const NLChangeAccount = /*@__PURE__*/ proxyCustomElement(class NLChangeAccount extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.handleOpenWelcomeModal = createEvent(this, "handleOpenWelcomeModal", 7);
        this.handleSwitchAccount = createEvent(this, "handleSwitchAccount", 7);
        this.isOpen = false;
        this.options = [];
        this.accounts = [];
        this.currentAccount = null;
        this.mode = false;
        this.darkMode = false;
        this.themeState = 'default';
        this.theme = 'default';
    }
    handleWindowClick() {
        if (this.wrapperRef.querySelector('.listClass')) {
            this.isOpen = false;
        }
    }
    toggleDropdown() {
        this.isOpen = !this.isOpen;
        this.calculateDropdownPosition();
    }
    watchPropHandler(newValue) {
        this.themeState = newValue;
    }
    watchModeHandler(newValue) {
        this.mode = newValue;
    }
    watchAccountsHandler(newValue) {
        this.options = newValue;
    }
    connectedCallback() {
        this.themeState = this.theme;
        this.mode = this.darkMode;
    }
    calculateDropdownPosition() {
        if (this.isOpen && this.buttonRef) {
            const buttonRect = this.buttonRef.getBoundingClientRect();
            this.ulRef.style.top = `${buttonRect.height}px`;
        }
    }
    handleChange(el) {
        this.handleSwitchAccount.emit(el);
    }
    handleOpenModal() {
        this.handleOpenWelcomeModal.emit();
    }
    render() {
        const listClass = `${this.isOpen ? 'listClass flex flex-col gap-2' : 'hidden'} w-full nl-select-list absolute z-10 left-0 shadow-md rounded-lg p-2 mt-1 after:h-4 after:absolute after:-bottom-4 after:start-0 after:w-full before:h-4 before:absolute before:-top-4 before:start-0 before:w-full`;
        const arrowClass = `${this.isOpen ? 'rotate-180' : 'rotate-0'} duration-300 flex-shrink-0 w-4 h-4 text-gray-500`;
        const filteredOptions = this.options && this.currentAccount ? this.options.filter(el => el.pubkey !== this.currentAccount.pubkey || el.authMethod !== this.currentAccount.authMethod) : [];
        return (h("div", { key: '4e15e39f7ac6a552bfc772396e3e9ef8eeca95cc', class: `theme-${this.themeState}` }, h("div", { key: 'eae10769ce35dc4cc072d2361c1ee1390c79c822', class: "relative", ref: el => (this.wrapperRef = el) }, h("button", { key: 'e585a44168809f27b99201f7e13bd5db5e4f6569', ref: el => (this.buttonRef = el), onClick: () => this.toggleDropdown(), type: "button", class: "nl-select peer py-3 px-4 flex items-center w-full justify-between border-transparent rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none dark:border-transparent" }, h("span", { key: '006ed9a67b57227d4dab51f0b6bcb8290cd9d3ac', class: "text-gray-500" }, "Switch profile"), h("svg", { key: '5f824a479165929698fab31b8837b89418587652', class: arrowClass, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, h("path", { key: '600914907723c9f8d01a15da357ccb825c1d1e6a', d: "m6 9 6 6 6-6" }))), h("ul", { key: '9b5b68724a3bce995e6b8b0a9d0eb653baedf79a', ref: el => (this.ulRef = el), class: listClass }, this.options &&
            filteredOptions.map(el => {
                const isShowImg = Boolean(el === null || el === void 0 ? void 0 : el.picture);
                const userName = el.name || el.nip05 || el.pubkey;
                const isShowUserName = Boolean(userName);
                return (h("li", { onClick: () => this.handleChange(el), class: "nl-select-option flex cursor-pointer items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm" }, h("div", { class: "uppercase font-bold w-full max-w-6 h-6 rounded-full border border-gray-400 flex justify-center items-center" }, isShowImg ? (h("img", { class: "w-full rounded-full", src: el.picture, alt: "Logo" })) : isShowUserName ? (userName[0]) : (h("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "w-full" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" })))), h("div", { class: "overflow-hidden flex flex-col w-full" }, h("div", { class: "truncate overflow-hidden" }, userName), h("nl-login-status", { info: el }))));
            }), h("li", { key: '936f2b75ca2dfca3483650d5d62fc50182cfc8f2', class: "first:pt-0 pt-2 border-t-[1px] first:border-none border-gray-300" }, h("div", { key: 'be0b4f29e70d8e2bc9fd1cc04c0fb43ad3dd5cac', onClick: () => this.handleOpenModal(), class: "nl-select-option flex cursor-pointer items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm" }, h("div", { key: 'bdd2a67e5763726666fcea91b0e7de67fe855994', class: "uppercase font-bold w-6 h-6 rounded-full border border-gray-400 flex justify-center items-center" }, h("svg", { key: 'f3a258f3e510ccb83b95bf3abecf65c248c8b0f1', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "w-4 h-4" }, h("path", { key: 'dafaa898f3e042531a923a9a77b94511895c6102', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M12 4.5v15m7.5-7.5h-15" }))), "Add profile"))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "theme": ["watchPropHandler"],
        "darkMode": ["watchModeHandler"],
        "accounts": ["watchAccountsHandler"]
    }; }
    static get style() { return NlChangeAccountStyle0; }
}, [0, "nl-change-account", {
        "accounts": [16],
        "currentAccount": [16],
        "darkMode": [4, "dark-mode"],
        "theme": [1],
        "isOpen": [32],
        "options": [32],
        "mode": [32],
        "themeState": [32]
    }, [[8, "click", "handleWindowClick"]], {
        "theme": ["watchPropHandler"],
        "darkMode": ["watchModeHandler"],
        "accounts": ["watchAccountsHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-change-account", "nl-login-status"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-change-account":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NLChangeAccount);
            }
            break;
        case "nl-login-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NLChangeAccount as N, defineCustomElement as d };

//# sourceMappingURL=nl-change-account2.js.map